export const setData = (data, setDataFunc, attachmentKey) => {
  if (!data) {
    return;
  }
  const attachments = data?.[attachmentKey] || [];
  setDataFunc({ [attachmentKey]: attachments });
};
